<div class="user-layout-wrapper">

  <div class="navbar-container">
    <nav class="app-navbar">
      <a class="navbar-logo" routerLink="/">
        <img src="assets/images/logo.svg" alt="Arcadia" />
      </a>
      <span class="navbar-spacer"></span>
      <ul class="nav-right-items">
        @if ((authShellVisible$ | async) || hasCookieSession) {
          <li class="nav-text-wrap">
            <a class="nav-text-link" routerLink="/user/search-engine">
              <i class="bi bi-search"></i>
              <span>Buscar vuelos</span>
            </a>
          </li>
          <li class="nav-hamburger-wrap">
            <button class="nav-icon-btn nav-hamburger-btn" aria-label="Menú" (click)="drawerOpen = true">
              <i class="bi bi-list"></i>
            </button>
          </li>
          <li class="nav-profile-wrap">
            <a class="nav-profile-link" routerLink="/user/profile">
              <span class="nav-profile-avatar">{{ (profile$ | async)?.initials || 'U' }}</span>
              <span class="nav-profile-name">{{ firstName((profile$ | async)?.fullName) }}</span>
            </a>
          </li>
        } @else {
          <button routerLink="/auth/sign-in" class="btn-signin">Iniciar Sesión</button>
        }
      </ul>
    </nav>
  </div>

  <div class="layout-body">
    <aside class="sidebar-col">
      <div class="sidebar-user-card">
        <div class="sidebar-avatar-wrap">
          <div class="sidebar-avatar">
            {{ (profile$ | async)?.initials || 'U' }}
          </div>
          <span class="online-dot"></span>
        </div>
        <p class="sidebar-name">{{ (profile$ | async)?.fullName || 'Usuario' }}</p>
        <p class="sidebar-email">{{ (profile$ | async)?.email || 'correo@ejemplo.com' }}</p>
      </div>
      <div class="sidebar-menu-card">
        <div class="menu-items-list">
          @for (item of usermenuItems; track $index) {
            <a class="menu-item"
              [ngClass]="{ active: isActive(item.url) || ($index === 0 && currentPath === null) }"
              [routerLink]="item.url">
              <i class="{{ item.icon }} menu-icon"></i>
              {{ item.label }}
            </a>
          }
        </div>

        <div class="sidebar-help-card">
          <div class="sidebar-help-card__header">
            <div class="sidebar-help-card__icon">
              <i class="bi bi-headset"></i>
            </div>
            <p class="sidebar-help-card__title">¿Necesitas ayuda con tu viaje?</p>
          </div>
          <p class="sidebar-help-card__subtitle">Nuestro equipo está siempre disponible para ayudarte.</p>
          <a class="sidebar-help-card__cta" href="https://wa.me/34655204586" target="_blank" rel="noopener">Contáctanos</a>
        </div>
      </div>

      <div class="sidebar-logout-card">
        <a class="menu-item danger" routerLink="/auth/sign-in">
          <i class="fas fa-sign-out-alt menu-icon"></i>
          Cerrar sesión
        </a>
      </div>
    </aside>

    <main class="layout-content">
      <router-outlet />
      <div class="layout-bottom-spacer"></div>
    </main>
  </div>

  <div class="mobile-drawer-overlay" [class.open]="drawerOpen" (click)="drawerOpen = false"></div>

  <div class="mobile-drawer" [class.open]="drawerOpen">
    <div class="drawer-user">
      <div class="drawer-avatar">
        <i class="bi bi-person"></i>
      </div>
      <div>
        <p class="drawer-name">{{ (profile$ | async)?.fullName || 'Usuario' }}</p>
        <p class="drawer-email">{{ (profile$ | async)?.email || '' }}</p>
      </div>
      <button class="drawer-close-btn" (click)="drawerOpen = false">
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="drawer-scroll">
      <div class="drawer-section-label">DASHBOARD</div>
      <div class="drawer-menu">
        @for (item of usermenuItems; track $index) {
          <a class="drawer-item"
            [ngClass]="{ active: isActive(item.url) }"
            [routerLink]="item.url"
            (click)="drawerOpen = false">
            <i class="{{ item.icon }}"></i>
            {{ item.label }}
          </a>
        }
      </div>

      <div class="drawer-footer">
        <a class="drawer-item danger" routerLink="/auth/sign-in" (click)="drawerOpen = false">
          <i class="fas fa-sign-out-alt"></i>
          Cerrar sesión
        </a>
      </div>
    </div>
  </div>

</div>